import React, { useState, useEffect } from 'react';
import { brandService } from '../../api/brandService';
import '../Common/Common.css';

function BrandForm({ brand, onSuccess, onCancel }) {
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
  });
  const [logo, setLogo] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBrands();
  }, []);

  useEffect(() => {
    if (brand) {
      setFormData({
        name: brand.name || '',
        slug: brand.slug || '',
      });
      if (brand.logo) {
        setImagePreview(brand.logo);
      }
    }
  }, [brand]);

  useEffect(() => {
    return () => {
      if (imagePreview && imagePreview.startsWith('blob:')) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  const fetchBrands = async () => {
    try {
      const response = await brandService.getBrands({ per_page: 100 });
      setBrands(response.data || []);
    } catch (err) {
      console.error('Error fetching brands:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      if (imagePreview && imagePreview.startsWith('blob:')) {
        URL.revokeObjectURL(imagePreview);
      }
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const submitData = new FormData();
    submitData.append('name', formData.name);
    submitData.append('slug', formData.slug);
    if (logo) {
      submitData.append('image', logo);
    }
    try {
      if (brand) {
        await brandService.updateBrand(brand.id, submitData);
      } else {
        await brandService.createBrand(submitData);
      }
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save brand');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="error-message">{error}</div>}

      <div className="form-group">
        <label>Brand Name *</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label>Slug *</label>
        <input
          type="text"
          name="slug"
          value={formData.slug}
          onChange={handleChange}
          required
          placeholder="brand-slug"
        />
      </div>

      <div className="form-group">
        <label>Logo {!brand && '*'}</label>
        <div className="upload-buttons">
          <label className="upload-btn">
            <input
              type="file"
              accept="image/*"
              disabled={loading}
              onChange={handleImageSelect}
              style={{ display: 'none' }}
            />
            Télécharger une image
          </label>
        </div>
        {imagePreview && (
          <div className="image-preview" style={{ marginTop: '10px' }}>
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                maxWidth: '200px',
                maxHeight: '200px',
                objectFit: 'contain',
                border: '1px solid #ddd',
                borderRadius: '4px',
                padding: '5px'
              }}
            />
          </div>
        )}
      </div>

      <div className="form-actions">
        <button type="button" onClick={onCancel} className="btn btn-secondary">
          Cancel
        </button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </form>
  );
}

export default BrandForm;
